module.exports = __webpack_public_path__ + "static/settings-sftp-a66d1026a023a39116935b33c7c4bfea.png";